export const EVENT_ASSIGNMENT_CREATED = 'assignment-created';
export const EVENT_PROPOSAL_ACCEPTED = 'proposal-accepted';
export const EVENT_PROPOSAL_CREATED = 'proposal-created';
